import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { welcomeKeepInTouchBackground } from '@/shared/styles/colors';
import { WELCOME_SECTION_BREAKPOINT } from '@/shared/styles/constants';

const ELFSIGHT_SCRIPT_SRC = 'https://elfsightcdn.com/platform.js';
const ELFSIGHT_APP_CLASS = 'elfsight-app-ead2ebf3-edb0-4c4c-9f9a-7e6ce200b2ff';

const WELCOME_MOBILE_MAX_WIDTH_PX = WELCOME_SECTION_BREAKPOINT - 1;
const MOBILE_MAX_WIDTH_MEDIA = `(max-width: ${WELCOME_MOBILE_MAX_WIDTH_PX}px)`;

const KeepInTouchInstagramGrid = () => {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const existingScript = document.querySelector(
      `script[src="${ELFSIGHT_SCRIPT_SRC}"]`,
    );
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = ELFSIGHT_SCRIPT_SRC;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <Wrapper>
      <ElfsightHost className={ELFSIGHT_APP_CLASS} data-elfsight-app-lazy="" />
      <SectionBlendOverlay aria-hidden />
    </Wrapper>
  );
};

const Wrapper = styled.div({
  position: 'relative',
  width: '100%',
  minHeight: 620,
  overflow: 'hidden',
  borderRadius: 6,
  isolation: 'isolate',
  [MOBILE_MAX_WIDTH_MEDIA]: {
    minHeight: 0,
    [`& .${ELFSIGHT_APP_CLASS}`]: {
      position: 'relative',
      zIndex: 0,
    },
  },
});

const ElfsightHost = styled.div({
  width: '100%',
});

const SectionBlendOverlay = styled.div({
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 0,
  height: 52,
  backgroundColor: welcomeKeepInTouchBackground,
  zIndex: 1,
  pointerEvents: 'none',
  transform: 'translateZ(0)',
});

export default KeepInTouchInstagramGrid;
